export const inProductsArray = (state) => Object.values(state.products);
export const byProductId = (state) => (id) => state.products[id];
